import React, { useRef } from 'react';
import {
    Box,
    Divider,
    Group,
    CloseOutlined,
    ArrowBackOutlined,
    IconButton,
    useMountEffect,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import TextInput from '../../TextInput/TextInput';

export const _ModalTextInput = ({
    inputRef,
    closeSuggestions,
    isCloseCtaVisible,
    clearCtaLabel,
    handleClearCta,
}: {
    inputRef: React.MutableRefObject<HTMLInputElement | null>;
    closeSuggestions: () => void;
    isCloseCtaVisible: boolean;
    clearCtaLabel: string;
    handleClearCta?: () => void;
}) => (
    <Box padding={{ base: 'xs', md: 'sm' }} paddingBottom="0">
        <Group direction="vertical" gap={{ base: 0, md: 'xs' }}>
            <Group.Item>
                <Group
                    gap={{ sm: 0, md: '2xs' }}
                    paddingX={{ sm: 0, md: 'xs' }}
                    alignItems="center"
                >
                    <Group.Item
                        alignContent="center"
                        height={{ base: 'md', md: 'xl' }}
                        marginTop={{ base: 0, md: '2xs' }}
                        marginBottom={{ base: 0, md: '2xs' }}
                    >
                        <IconButton
                            icon={ArrowBackOutlined}
                            variant="subtle"
                            kind="link"
                            size="md"
                            label={t`Close`}
                            onClick={closeSuggestions}
                        />
                    </Group.Item>
                    <Group.Item flexGrow={10} alignSelf="center">
                        <TextInput ref={inputRef} />
                    </Group.Item>
                    {isCloseCtaVisible && (
                        <Group.Item>
                            <IconButton
                                icon={CloseOutlined}
                                variant="subtle"
                                kind="link"
                                size="sm"
                                label={clearCtaLabel}
                                onClick={handleClearCta}
                            />
                        </Group.Item>
                    )}
                </Group>
            </Group.Item>
            <Group.Item>
                <Divider />
            </Group.Item>
        </Group>
    </Box>
);

const ModalTextInput = () => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const {
        closeSuggestions,
        hasTextInputValue,
        clearCtaLabel,
        handleClearCta,
    } = useSearchBarContext();

    useMountEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }

        return () => {
            if (inputRef.current) {
                inputRef.current.blur();
            }
        };
    });

    return (
        <_ModalTextInput
            inputRef={inputRef}
            closeSuggestions={closeSuggestions}
            isCloseCtaVisible={hasTextInputValue}
            clearCtaLabel={clearCtaLabel}
            handleClearCta={handleClearCta}
        />
    );
};

export default ModalTextInput;
